import { render, staticRenderFns } from "./VideoPlayerWithChapters.vue?vue&type=template&id=1fe5f3bf&"
import script from "./VideoPlayerWithChapters.vue?vue&type=script&lang=js&"
export * from "./VideoPlayerWithChapters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports